import React from 'react'
import _ from 'lodash/fp'
import { connect } from 'react-redux'
import { useMutation } from 'react-apollo'
import gql from 'graphql-tag'

import { builder, BuilderComponent } from '@builder.io/react'
import Checkbox from '@material-ui/core/Checkbox'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import Paper from '@material-ui/core/Paper'

import BottomBar from '../../components/BottomBar'

import * as ProfileReducer from '../../reducers/profile'

builder.init('32eea804311a4d17817f2e534ded7af8')

const initSignupMutation = gql`
mutation($itemId: ID!) {
  signUpForMembership(input: {
    itemId: $itemId
  })
}
`

const tryOpenInApp = (url, history, options = { replace: false, fallbackUrl: undefined, timeout: 0 }) => {
  const shouldFallback = Boolean(options.fallbackUrl)

  window.location = url

  if (shouldFallback) {
    setTimeout(() => {
      const fallbackMethod = options.replace ? 'replace' : 'push'
      const fallbackFunc = _.get(fallbackMethod, history)
      fallbackFunc(options.fallbackUrl)
    }, options.timeout)
  }
}

const isSignedIn = props => _.flow(
  _.get('profile'),
  _.negate(_.isEmpty)
)(props)

const isMember = props => _.flow(
  _.get('profile.apolloUser.memberships'),
  _.negate(_.isEmpty)
)(props)

const App = props => {
  const [termsConfirmed, setTermsConfirmed] = React.useState(false)
  const [initSignup, signupData] = useMutation(initSignupMutation)
  const loading = _.get('called', signupData) && !_.get('error', signupData)

  React.useEffect(() => {
    if (!isSignedIn(props)) {
      props.history.push('/open')
      return
    }
    if (isMember(props)) {
      const handle = _.get('profile.handle', props)
      props.history.push(`/u/${handle}/open`)
    }
  }, [])

  const handleRightClick = async () => {
    await initSignup({ variables: { itemId: 'GLFR_OPEN' } })
    props.history.replace('/open/accept', { open: true, app: true })
  }

  const handleLeftClick = () => {
    tryOpenInApp('glfr://', props.history, { fallbackUrl: '/open' })
  }

  return (
    <div style={{
      minHeight: 'calc(100vh - 64px - 64px)',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-between'

    }}
    >
      <div style={{ overflowY: 'auto' }}>
        <BuilderComponent
          model='page'
          entry='e6a614e006fe4785b2382b8d62732b13'
        />
      </div>
      <Paper
        style={{
          marginBottom: 84,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          padding: '0 16px',
          borderBottomLeftRadius: 0,
          borderBottomRightRadius: 0
        }}
        elevation={2}
      >
        <BuilderComponent
          model='content-sections'
          entry='ca33a4db7f684cf9bb420aa164debe2b'
        />

        <FormControlLabel
          value='Accepter'
          control={(
            <Checkbox
              onChange={(_e, checked) => setTermsConfirmed(checked)}
              color='primary'
              checked={termsConfirmed}
            />
          )}
          label='Accepter'
          labelPlacement='end'
          style={{ alignSelf: 'flex-end' }}
        />
      </Paper>
      <BottomBar
        rightText='Tilmeld'
        leftText='Luk'
        loading={loading}
        disabledRight={!termsConfirmed}
        onRightClick={handleRightClick}
        onLeftClick={handleLeftClick}
        invertRight
      />
    </div>
  )
}

export default _.compose(
  connect(
    s => {
      const profile = ProfileReducer.selectors.getProfile(s)
      return {
        profile
      }
    },
    d => {
      return {
        loadProfile: () => d(ProfileReducer.actions.loadRequest(Date.now()))
      }
    }
  )
)(App)
